import Reveal from '../Reveal/Reveal'
import styles from './Section.module.css'

const Section = ({ id, index, eyebrow, title, lead, children, className = '' }) => (
  <section id={id} className={`${styles.section} ${className}`.trim()}>
    <div className="container">
      <Reveal className={styles.header}>
        <p className={styles.eyebrow}>
          {index && <span className={styles.index}>{index}</span>}
          <span className={styles.rule} aria-hidden="true" />
          {eyebrow || title}
        </p>

        <h2 className={styles.title}>{title}</h2>

        {lead && <p className={styles.lead}>{lead}</p>}
      </Reveal>

      {children}
    </div>
  </section>
)

export default Section
